import {
  filter,
  tap,
  ignoreElements,
  switchMap,
  mergeMap,
  catchError,
} from 'rxjs/operators'
import {of, concat, from} from 'rxjs'
import {Epic} from 'redux-observable'
import {RootState, AppActions} from 'app/rootReducer'
import {SettingsService} from 'services/api'
import {settingsActions} from '../settingsSlice'
import Toast from 'components/Basic/Toast'
// Removed circular dependency - these actions are handled elsewhere

/* eslint-disable @typescript-eslint/no-explicit-any */
const getSearchUsersGroupsEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.getSearchUsersGroups.match),
    switchMap(({payload}) =>
      from(SettingsService.getSearchUsersGroups(payload)).pipe(
        mergeMap(({data}) => [
          settingsActions.getSearchUsersGroupsSuccess(data),
        ]),
        catchError((message: string) =>
          concat(of(settingsActions.getSearchUsersGroupsFailure(message))),
        ),
      ),
    ),
  )

const getSearchUsersGroupsFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.getSearchUsersGroupsFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const getUserGroupDetailsEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.getUserGroupDetails.match),
    switchMap(({payload}) =>
      from(SettingsService.getUserGroupDetails(payload)).pipe(
        mergeMap(({data: {response}}) => [
          settingsActions.getUserGroupDetailsSuccess(
            (response && response[payload]) || {},
          ),
        ]),
        catchError((message: string) =>
          concat(of(settingsActions.getUserGroupDetailsFailure(message))),
        ),
      ),
    ),
  )

const getUserGroupDetailsFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.getUserGroupDetailsFailure.match),
    tap(() =>
      Toast({message: 'Error, unable to fetch user groups. ', type: 'error'}),
    ),
    ignoreElements(),
  )

export const userEpics = [
  getSearchUsersGroupsEpic,
  getSearchUsersGroupsFailureEpic,
  getUserGroupDetailsEpic,
  getUserGroupDetailsFailureEpic,
]
